import ModelBaseClass from "@quasidea/oas-client-react/lib/ModelBaseClass";
import RtReconciliationUploadRtReportRequest from "../RtReconciliationUploadRtReportRequest";
import ModelProxyClass from "./ModelProxyClass";
import FileAsset from "../FileAsset";


/**
 * @class RtReconciliationUploadRtReportRequestBase
 * @extends ModelBaseClass
 * @property {number} tenantId (int64)
 * @property {'M3tRms'} rtVendorType
 * @property {FileAsset} reportFileAsset
 */
class RtReconciliationUploadRtReportRequestBase extends ModelBaseClass {
	/**
	 * @type {number} tenantId (int64)
	 */
	tenantId;
	/**
	 * @type {'M3tRms'} rtVendorType
	 */
	rtVendorType;
	/**
	 * @type {FileAsset} reportFileAsset
	 */
	reportFileAsset;

	/**
	 * Instantiates a new instance of RtReconciliationUploadRtReportRequest based on the generic object being passed in (typically from a JSON object)
	 * @param {object} genericObject
	 * @return {RtReconciliationUploadRtReportRequest}
	 */
	static create(genericObject) {
		const newRtReconciliationUploadRtReportRequest = new RtReconciliationUploadRtReportRequest();
		newRtReconciliationUploadRtReportRequest.instantiate(_modelDefinition, genericObject, ModelProxyClass.createByClassName);
		return newRtReconciliationUploadRtReportRequest;
	}

	/**
	 * Instantiates a new array of RtReconciliationUploadRtReportRequest based on the generic array being passed in (typically from a JSON array)
	 * @param {[object]} genericArray
	 * @return {[RtReconciliationUploadRtReportRequest]}
	 */
	static createArray(genericArray) {
		if (genericArray === null) {
			return null;
		}

		const newRtReconciliationUploadRtReportRequestArray = [];
		genericArray.forEach(genericObject => {
			newRtReconciliationUploadRtReportRequestArray.push(RtReconciliationUploadRtReportRequest.create(genericObject));
		});
		return newRtReconciliationUploadRtReportRequestArray;
	}
}

const _modelDefinition = [
	ModelBaseClass.createModelProperty('tenantId', 'integer'),
	ModelBaseClass.createModelProperty('rtVendorType', 'string'),
	ModelBaseClass.createModelProperty('reportFileAsset', 'FileAsset'),
];

export default RtReconciliationUploadRtReportRequestBase;
